import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

import { Routes } from '../../definitions/routes';

export function setupCartao(): void {
  const modules = [{
    entry: 'solicitar-2via',
    id: 'solicitar-2via',
    name: 'beneficiary.solicitar-2via',
    route: Routes.SOLICITAR_VIA,
    order: 1,
    closeable: true,
  }];

  applicationModuleRegistry.registerGroup({
    entry: 'cartao',
    id: 'cartao',
    name: 'beneficiary.cartao',
    modules,
    order: 3,
  });
}
